import React, {
  Fragment,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import sicon1 from "../../icons/icon_google.svg";
import appleIcon from "../../icons/Apple_icon.png";
import coinIcon from "../../images/site_logo/TC-Logo-icon.png";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import "./style.css";
import { API_URL } from "../../constant";
import {
  FaEye,
  FaEyeSlash,
  FaLink,
  FaCopy,
  FaSearch,
  FaTimes,
} from "react-icons/fa";
import { IoArrowBack, IoArrowForward } from "react-icons/io5";
import { NavLink } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";


function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [passwordVisible, setPasswordVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [captchaToken, setCaptchaToken] = useState(null); // recaptcha

  // State for referral code
  const [referralCode, setReferralCode] = useState(null);
  // State for login data
  const [loginData, setLoginData] = useState(null);
  // Ref for auto-dismiss timeout
  const autoDismissRef = useRef(null);

  // Senior Agents state - Matching WorkWithTCUKPage structure
  const [seniorAgents, setSeniorAgents] = useState([]);
  const [displayAgents, setDisplayAgents] = useState([]); // Agents to display
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoSliding, setIsAutoSliding] = useState(true);
  const [isLoadingAgents, setIsLoadingAgents] = useState(true);
  const [agentsError, setAgentsError] = useState(null);
  const [searchQuery, setSearchQuery] = useState(""); // Search input value

  // New state for hover preview (like WorkWithTCUKPage)
  const [hoveredAgent, setHoveredAgent] = useState(null);
  const [isHovering, setIsHovering] = useState(false);
  const [isPreviewVisible, setIsPreviewVisible] = useState(false); // Control visibility separately

  // State for marquee animation
  const [marqueeAnimation, setMarqueeAnimation] = useState("none");
  const [isMarqueePaused, setIsMarqueePaused] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [maxScroll, setMaxScroll] = useState(0);

  // State for selected user type - Add this state
  const [selectedUserType, setSelectedUserType] = useState("customer");

  const slideIntervalRef = useRef(null);
  const searchInputRef = useRef(null); // Ref for search input
  const marqueeRef = useRef(null); // Ref for marquee container
  const agentNameRefs = useRef([]); // Refs for agent name elements
  const marqueeContentRef = useRef(null); // Ref for marquee content
  const marqueeResizeObserver = useRef(null); // For observing size changes
  const [lastInteractionTime, setLastInteractionTime] = useState(Date.now());
  const hoverTimeoutRef = useRef(null); // Ref for hover timeout

  //search error
  const [searchError, setSearchError] = useState("");

  const [displayCustomerAgents, setDisplayCustomerAgents] = useState([]);
  const [isLoadingCustomerAgents, setIsLoadingCustomerAgents] = useState(true);
  const [customerAgentsError, setCustomerAgentsError] = useState(null);
  // const [agentsCustomerError, setAgentsCustomerError] = useState(null);

  // captcha handler
  const onCaptchaChange = (token) => {
      setCaptchaToken(token);
  };

  const validateLoginForm = () => {
    if (!email.trim()) {
      setMessage({
        text: "Email is required.",
        type: "error",
      });
      return false;
    }

    if (email.length > 255) {
      setMessage({ text: "Please enter a valid email address.", type: "error" });
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage({
        text: "Please enter a valid email address.",
        type: "error",
      });
      return false;
    }

    if (!password) {
      setMessage({
        text: "Password is required.",
        type: "error",
      });
      return false;
    }

    if (password.length < 8) {
      setMessage({ text: "Email or Password incorrect.", type: "error" });
      return false;
    }

    if (password.length > 50) {
      setMessage({ text: "Email or Password incorrect.", type: "error" });
      return false;
    }

    if (!captchaToken) {
      setMessage({
        text: "Captcha verification is required.",
        type: "error",
      });
      return false;
    }

    return true;
  };

  // Initialize sliding interval with condition for minimum cards on large devices
  useEffect(() => {
    // Check if we should auto-slide
    const shouldAutoSlide =
      isAutoSliding &&
      displayAgents.length > 0 &&
      (!window.matchMedia("(min-width: 992px)").matches ||
        displayAgents.length >= 3);

    if (shouldAutoSlide) {
      slideIntervalRef.current = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % displayAgents.length);
      }, 4000);
    } else if (slideIntervalRef.current) {
      // Clear interval if conditions not met
      clearInterval(slideIntervalRef.current);
      slideIntervalRef.current = null;
    }

    return () => {
      if (slideIntervalRef.current) {
        clearInterval(slideIntervalRef.current);
      }
    };
  }, [isAutoSliding, displayAgents.length]);

  // Initialize referral code from URL or localStorage on component mount
  useEffect(() => {
    // Get referral code from URL parameter
    const params = new URLSearchParams(window.location.search);
    const urlRef = params.get("ref");

    if (urlRef) {
      // Store in localStorage for persistence
      localStorage.setItem("login_referral_code", urlRef);
      setReferralCode(urlRef);
      console.log("Referral code from URL (login):", urlRef);
    } else {
      // Check if we have a stored referral code
      const storedRef = localStorage.getItem("login_referral_code");
      if (storedRef) {
        setReferralCode(storedRef);
        console.log("Referral code from localStorage (login):", storedRef);
      }
    }
  }, []);

  // Function to start marquee animation
  const startMarqueeAnimation = useCallback(() => {
    if (!marqueeContentRef.current || !marqueeRef.current) return;

    const containerWidth = marqueeRef.current.offsetWidth;
    const contentWidth = marqueeContentRef.current.scrollWidth;

    // Only animate if content is wider than container
    if (contentWidth > containerWidth && !isMarqueePaused) {
      const duration = Math.max(20, (contentWidth / 100) * 1.5); // Calculate duration based on width
      const animation = `marquee ${duration}s linear infinite`;
      setMarqueeAnimation(animation);

      if (!isMarqueePaused) {
        marqueeContentRef.current.style.transform = "translateX(0)";
        marqueeContentRef.current.style.transition = "none";
        marqueeContentRef.current.style.animation = animation;
        setScrollPosition(0);
      }
    } else {
      setMarqueeAnimation("none");
    }
  }, [isMarqueePaused]);

  // Function to fetch senior agents from API (similar to WorkWithTCUKPage but for customer agents)
  const fetchSeniorAgents = useCallback(async () => {
    try {
      setIsLoadingAgents(true);
      setAgentsError(null);

      const url = `${API_URL}/api/senior-customer-advertising-agents/public`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Format agents for UI (like WorkWithTCUKPage)
      const colors = [
        "#2D4CA8",
        "#9F4AFF",
        "#FF6B6B",
        "#4CAF50",
        "#FF9800",
        "#9C27B0",
        "#2196F3",
        "#FF5722",
      ];
      const formattedAgents = data.agents.map((agent, index) => {
        // Generate QR code URL for the referral link
        const referralLink = `${window.location.origin}/create-account?ref=${agent.agent_code}`;
        const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(
          referralLink,
        )}`;

        // Generate a color based on agent ID for UI consistency
        const colorIndex = agent.agent_id
          ? agent.agent_id % colors.length
          : index % colors.length;

        return {
          id: agent.agent_id || agent.customer_id,
          customer_id: agent.customer_id,
          agent_id: agent.agent_id,
          fullName: agent.full_name || `${agent.first_name} ${agent.last_name}`,
          firstName: agent.first_name,
          lastName: agent.last_name,
          location: agent.country || "Unknown",
          region: agent.region,
          position: agent.position || "Senior Customer Advertising Agent",
          referralLink: referralLink,
          qrCode: qrCodeUrl,
          profilePic:
            agent.profile_image ||
            `https://randomuser.me/api/portraits/${
              index % 2 === 0 ? "men" : "women"
            }/${(index % 50) + 1}.jpg`,
          color: colors[colorIndex],
          email: agent.email,
          phoneNumber: agent.phone_number,
          memberSince: agent.member_since,
          agentSince: agent.agent_since,
          isActive: agent.is_active,
          agentCode: agent.agent_code,
          shortName:
            agent.first_name + " " + agent.last_name ||
            agent.fullName?.split(" ")[0]?.charAt(0) +
              ". " +
              agent.fullName?.split(" ")[1] ||
            agent.fullName,
        };
      });

      setSeniorAgents(formattedAgents);
      setDisplayAgents(formattedAgents); // Set display agents to all agents initially

      // Reset slide to 0 when new data loads
      setCurrentSlide(0);
    } catch (error) {
      console.error("Failed to fetch senior agents:", error);
      setAgentsError(
        "Failed to load senior agents. Showing sample data instead.",
      );

      // Fallback to dummy data if API fails
      const fallbackData = [
        {
          id: 1,
          fullName: "Era Morgan",
          shortName: "E. Morgan",
          location: "UK",
          position: "Senior Customer Advertising Agent",
          referralLink: `${window.location.origin}/create-account?ref=6321`,
          qrCode: `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(
            `${window.location.origin}/create-account?ref=6321`,
          )}`,
          profilePic: "https://randomuser.me/api/portraits/women/65.jpg",
          color: "#2D4CA8",
          agentCode: "6321",
        },
        {
          id: 2,
          fullName: "Malcolm Summers",
          shortName: "M. Summers",
          location: "Sri Lanka",
          position: "Senior Customer Advertising Agent",
          referralLink: `${window.location.origin}/create-account?ref=2116`,
          qrCode: `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(
            `${window.location.origin}/create-account?ref=2116`,
          )}`,
          profilePic: "https://randomuser.me/api/portraits/men/32.jpg",
          color: "#9F4AFF",
          agentCode: "2116",
        },
        {
          id: 3,
          fullName: "Kathy Godridge",
          shortName: "K. Godridge",
          location: "Switzerland",
          position: "Senior Customer Advertising Agent",
          referralLink: `${window.location.origin}/create-account?ref=1234`,
          qrCode: `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(
            `${window.location.origin}/create-account?ref=1234`,
          )}`,
          profilePic: "https://randomuser.me/api/portraits/women/44.jpg",
          color: "#FF6B6B",
          agentCode: "1234",
        },
        {
          id: 4,
          fullName: "Alex Johnson",
          shortName: "A. Johnson",
          location: "Australia",
          position: "Senior Customer Advertising Agent",
          referralLink: `${window.location.origin}/create-account?ref=3215`,
          qrCode: `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(
            `${window.location.origin}/create-account?ref=3215`,
          )}`,
          profilePic: "https://randomuser.me/api/portraits/men/67.jpg",
          color: "#4CAF50",
          agentCode: "3215",
        },
        {
          id: 5,
          fullName: "Sarah Williams",
          shortName: "S. Williams",
          location: "Germany",
          position: "Senior Customer Advertising Agent",
          referralLink: `${window.location.origin}/create-account?ref=4521`,
          qrCode: `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(
            `${window.location.origin}/create-account?ref=4521`,
          )}`,
          profilePic: "https://randomuser.me/api/portraits/women/33.jpg",
          color: "#FF9800",
          agentCode: "4521",
        },
      ];
      setSeniorAgents(fallbackData);
      setDisplayAgents(fallbackData);
    } finally {
      setIsLoadingAgents(false);
    }
  }, []);


  // Fetch agents on component mount
  useEffect(() => {
    fetchSeniorAgents();
  }, []);

  const fetchCustomerAgents = async () => {
    try {
      setIsLoadingCustomerAgents(true);
      setCustomerAgentsError(null);

      const response = await fetch(`${API_URL}/api/public/customers/agents`, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      const formattedCustomerAgents = (data.agents || []).map((agent) => ({
        id: agent.user_id,
        fullName: `${agent.first_name || ""} ${agent.last_name || ""}`.trim(),
        location: agent.country || "Unknown",
      }));

      setDisplayCustomerAgents(formattedCustomerAgents);
    } catch (error) {
      setCustomerAgentsError("Failed to load customer agents.");
    } finally {
      setIsLoadingCustomerAgents(false);
    }
  };


  useEffect(() => {
    fetchCustomerAgents();
  }, []);

  // Focus search input on page load/refresh
  useEffect(() => {
    // Focus the search input after components are fully loaded
    const focusTimer = setTimeout(() => {
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }, 300); // 300ms delay to ensure everything is loaded

    return () => clearTimeout(focusTimer);
  }, []);

  // Start marquee animation when displayAgents changes
  useEffect(() => {
    // Use setTimeout to ensure DOM is updated
    const timer = setTimeout(() => {
      startMarqueeAnimation();
    }, 100);

    return () => clearTimeout(timer);
  }, [displayAgents, startMarqueeAnimation]);

  // Handle resize and start marquee
  useEffect(() => {
    const handleResize = () => {
      startMarqueeAnimation();
      // Recalculate max scroll
      if (marqueeContentRef.current && marqueeRef.current) {
        const containerWidth = marqueeRef.current.offsetWidth;
        const contentWidth = marqueeContentRef.current.scrollWidth;
        setMaxScroll(contentWidth - containerWidth);
      }
    };

    window.addEventListener("resize", handleResize);

    // Set up ResizeObserver for the marquee container
    if (marqueeRef.current && !marqueeResizeObserver.current) {
      marqueeResizeObserver.current = new ResizeObserver(() => {
        startMarqueeAnimation();
        // Recalculate max scroll
        if (marqueeContentRef.current && marqueeRef.current) {
          const containerWidth = marqueeRef.current.offsetWidth;
          const contentWidth = marqueeContentRef.current.scrollWidth;
          setMaxScroll(contentWidth - containerWidth);
        }
      });
      marqueeResizeObserver.current.observe(marqueeRef.current);
    }

    return () => {
      window.removeEventListener("resize", handleResize);
      if (marqueeResizeObserver.current) {
        marqueeResizeObserver.current.disconnect();
      }
    };
  }, [startMarqueeAnimation]);

  // Calculate max scroll when displayAgents changes
  useEffect(() => {
    if (marqueeContentRef.current && marqueeRef.current) {
      const containerWidth = marqueeRef.current.offsetWidth;
      const contentWidth = marqueeContentRef.current.scrollWidth;
      setMaxScroll(contentWidth - containerWidth);
    }
  }, [displayAgents]);

  // Function to scroll marquee left
  const scrollLeft = () => {
    // Update interaction timestamp
    setLastInteractionTime(Date.now());

    if (marqueeContentRef.current) {
      // If auto-scroll is running, pause it first
      if (!isMarqueePaused) {
        setIsMarqueePaused(true);
      }

      const newPosition = Math.max(0, scrollPosition - 200);
      setScrollPosition(newPosition);
      marqueeContentRef.current.style.transform = `translateX(-${newPosition}px)`;
      marqueeContentRef.current.style.transition = "transform 0.3s ease";
      marqueeContentRef.current.style.animation = "none"; // Remove animation
    }
  };

  // Function to scroll marquee right
  const scrollRight = () => {
    // Update interaction timestamp
    setLastInteractionTime(Date.now());

    if (marqueeContentRef.current) {
      // If auto-scroll is running, pause it first
      if (!isMarqueePaused) {
        setIsMarqueePaused(true);
      }

      const newPosition = Math.min(maxScroll, scrollPosition + 200);
      setScrollPosition(newPosition);
      marqueeContentRef.current.style.transform = `translateX(-${newPosition}px)`;
      marqueeContentRef.current.style.transition = "transform 0.3s ease";
      marqueeContentRef.current.style.animation = "none"; // Remove animation
    }
  };

  // Function to toggle marquee pause/play
  const toggleMarqueePause = () => {
    // Update interaction timestamp when user manually toggles
    setLastInteractionTime(Date.now());

    const newPausedState = !isMarqueePaused;
    setIsMarqueePaused(newPausedState);

    if (marqueeContentRef.current) {
      if (newPausedState) {
        // When pausing, switch to manual transform
        marqueeContentRef.current.style.animation = "none";
        marqueeContentRef.current.style.transform = `translateX(-${scrollPosition}px)`;
      } else {
        // When playing, restart animation from beginning
        marqueeContentRef.current.style.transform = "translateX(0)";
        marqueeContentRef.current.style.animation = marqueeAnimation;
        marqueeContentRef.current.style.animationPlayState = "running";
        setScrollPosition(0);
      }
    }
  };

  // Auto-resume marquee after 5 seconds of inactivity
  useEffect(() => {
    let resumeTimer;

    if (isMarqueePaused) {
      // Set a timer to resume auto-play after 5 seconds of no interaction
      resumeTimer = setTimeout(() => {
        const timeSinceLastInteraction = Date.now() - lastInteractionTime;

        // Only resume if it's been more than 5 seconds since last interaction
        if (timeSinceLastInteraction >= 5000) {
          // Check if we're at the end of the scroll
          if (scrollPosition >= maxScroll) {
            // If at the end, reset to start and resume
            setScrollPosition(0);
            setIsMarqueePaused(false);

            if (marqueeContentRef.current) {
              marqueeContentRef.current.style.transform = "translateX(0)";
              marqueeContentRef.current.style.animation = marqueeAnimation;
              marqueeContentRef.current.style.animationPlayState = "running";
            }
          } else {
            // Not at the end, just resume auto-play
            setIsMarqueePaused(false);

            if (marqueeContentRef.current) {
              // Restart animation from current position by calculating appropriate animation
              const containerWidth = marqueeRef.current?.offsetWidth || 0;
              const contentWidth = marqueeContentRef.current.scrollWidth;
              const remainingDistance =
                contentWidth - containerWidth - scrollPosition;

              if (remainingDistance > 0) {
                const duration = Math.max(20, (remainingDistance / 100) * 1.5);
                const animation = `marqueeResume ${duration}s linear forwards`;

                // Create a custom animation for resuming from current position
                marqueeContentRef.current.style.animation = animation;
                marqueeContentRef.current.style.animationPlayState = "running";

                // Add a custom keyframe for resuming
                const styleSheet = document.createElement("style");
                styleSheet.textContent = `
                @keyframes marqueeResume {
                  0% {
                    transform: translateX(-${scrollPosition}px);
                  }
                  100% {
                    transform: translateX(-${contentWidth - containerWidth}px);
                  }
                }
              `;
                document.head.appendChild(styleSheet);

                // Clean up the style element after animation completes
                setTimeout(() => {
                  if (styleSheet.parentNode) {
                    styleSheet.parentNode.removeChild(styleSheet);
                  }
                }, duration * 1000);
              }
            }
          }
        }
      }, 5000); // Check every 5 seconds
    }

    return () => {
      if (resumeTimer) {
        clearTimeout(resumeTimer);
      }
    };
  }, [
    isMarqueePaused,
    lastInteractionTime,
    scrollPosition,
    maxScroll,
    marqueeAnimation,
  ]);

  // Clean up hover timeout on unmount
  useEffect(() => {
    return () => {
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
    };
  }, []);

  // Handle hover events for agent names
  const handleAgentNameMouseEnter = (agent, index, e) => {
    // Clear any existing timeout
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }

    // Set hovered agent immediately
    setHoveredAgent(agent);

    // Show preview after a small delay (for smoother transition)
    hoverTimeoutRef.current = setTimeout(() => {
      setIsPreviewVisible(true);
    }, 100);
  };

  const handleAgentNameMouseLeave = () => {
    // Clear the hover timeout if it exists
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }

    // Hide preview with a small delay to prevent flickering when moving between items
    hoverTimeoutRef.current = setTimeout(() => {
      if (!isHovering) {
        setIsPreviewVisible(false);
      }
    }, 150);
  };

  const handlePreviewMouseEnter = () => {
    // Clear any timeout that would hide the preview
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }
    setIsHovering(true);
  };

  const handlePreviewMouseLeave = () => {
    // Set a timeout to hide preview
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }

    hoverTimeoutRef.current = setTimeout(() => {
      setIsHovering(false);
      setIsPreviewVisible(false);
    }, 200);
  };

  // Handle user type change - Add this function
  const handleUserTypeChange = (type) => {
    setSelectedUserType(type);
    setIsAutoSliding(false);
    setCurrentSlide(0);

    // Clear search when changing user type
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
    setSearchQuery("");

    // Only resume auto-sliding if on mobile or if there are enough cards on desktop
    const shouldResume =
      !window.matchMedia("(min-width: 992px)").matches ||
      seniorAgents.length >= 3;
    if (shouldResume) {
      setTimeout(() => setIsAutoSliding(true), 5000);
    }
  };

  // Handle search button click - get value from input ref and filter (like WorkWithTCUKPage)
  const handleSearchClick = () => {
    if (!searchInputRef.current) return;

    const query = searchInputRef.current.value.trim();
    setSearchQuery(query); // Update state for display purposes

    if (!query) {
      // If search query is empty, show all agents
      setDisplayAgents(seniorAgents);
      setSearchError("Please enter a search term.");

      // Only resume auto-sliding if on mobile or if there are enough cards on desktop
      const shouldResume =
        !window.matchMedia("(min-width: 992px)").matches ||
        seniorAgents.length >= 3;
      setIsAutoSliding(shouldResume);
      return;
    }

    // Too short
    if (query.length < 3) {
      setSearchError("Search must contain at least 3 characters.");
      return;
    }

    // Too long
    if (query.length > 255) {
      setSearchError("Search must not exceed 255 characters.");
      return;
    }

    // Perform search only when button is clicked
    const searchTerm = query.toLowerCase();
    const results = seniorAgents.filter(
      (agent) =>
        agent.fullName.toLowerCase().includes(searchTerm) ||
        agent.location.toLowerCase().includes(searchTerm) ||
        (agent.agentCode &&
          agent.agentCode.toLowerCase().includes(searchTerm)) ||
        (agent.email && agent.email.toLowerCase().includes(searchTerm)),
    );

    setDisplayAgents(results);
    setCurrentSlide(0); // Reset to first slide
    setIsAutoSliding(false); // Always stop auto sliding when showing search results
  };

  // Handle reset search - show all agents again (like WorkWithTCUKPage)
  const handleResetSearch = () => {
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
      searchInputRef.current.focus(); // Keep focus on input after reset
    }
    setSearchQuery("");
    setSearchError(""); //  clear error
    setDisplayAgents(seniorAgents);
    setCurrentSlide(0);

    // Only resume auto-sliding if on mobile or if there are enough cards on desktop
    const shouldResume =
      !window.matchMedia("(min-width: 992px)").matches ||
      seniorAgents.length >= 3;
    setIsAutoSliding(shouldResume);
  };

  // Handle card click - open referral link (like WorkWithTCUKPage)
  const handleCardClick = (link) => {
    window.open(link, "_blank");
  };

  // Handle copy referral link (like WorkWithTCUKPage)
  const handleCopyLink = (link, e) => {
    e.stopPropagation();
    navigator.clipboard
      .writeText(link)
      .then(() => {
        alert("Referral link copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  // Function to open URL in new tab with fallback for different browsers
  const openInNewTab = (url) => {
    try {
      // Try to open with window.open first
      const newWindow = window.open(url, "_blank", "noopener,noreferrer");

      if (newWindow) {
        return newWindow;
      }

      // Fallback for browsers that block window.open
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Return a dummy object to prevent errors
      return { closed: true };
    } catch (error) {
      console.error("Error opening new tab:", error);
      // Last resort - navigate in current window
      window.location.href = url;
      return { closed: true };
    }
  };

  // Function to clear form fields
  const clearFormFields = () => {
    setEmail("");
    setPassword("");
    setPasswordVisible(false);
  };

  // Function to handle dismiss message
  const handleDismissMessage = () => {
    // Clear the auto-dismiss timeout if it exists
    if (autoDismissRef.current) {
      clearTimeout(autoDismissRef.current);
      autoDismissRef.current = null;
    }
    setMessage({ text: "", type: "" });
    // Also clear login data when dismissing message
    setLoginData(null);
  };

  // Function to clear message after delay
  const clearMessageAfterDelay = (delay = 10000) => {
    // Clear any existing timeout
    if (autoDismissRef.current) {
      clearTimeout(autoDismissRef.current);
    }

    // Set new timeout
    autoDismissRef.current = setTimeout(() => {
      setMessage({ text: "", type: "" });
      // Also clear login data when message auto-dismisses
      setLoginData(null);
    }, delay);
  };

  // Clean up timeout on component unmount
  useEffect(() => {
    return () => {
      if (autoDismissRef.current) {
        clearTimeout(autoDismissRef.current);
      }
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
    };
  }, []);

  const handleGoogleLogin = () => {
    // Use the referral code from state (which could be from URL or localStorage)
    const callbackUrl = `${window.location.origin}/auth/google/callback`;
    let googleAuthUrl = `${API_URL}/api/auth/google?callback=${encodeURIComponent(
      callbackUrl,
    )}`;

    // Add referral code to Google OAuth URL if present
    if (referralCode) {
      googleAuthUrl += `&ref=${encodeURIComponent(referralCode)}`;
      localStorage.setItem("pending_oauth_referral", referralCode);
      console.log("🔗 Opening Google OAuth with referral:", referralCode);
    }

    // Set flags for Google OAuth login
    sessionStorage.setItem("just_logged_in", "true");
    localStorage.setItem("just_logged_in_timestamp", Date.now().toString());

    // Open Google OAuth in same tab
    window.location.href = googleAuthUrl;
  };

  const handleAppleLogin = () => {
    window.open(`${API_URL}/api/auth/apple`, "_blank");
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    // Check reCAPTCHA
        // if (!captchaToken) {
        //   setMessage({
        //       text: 'Please verify that you are not a robot.',
        //       type: 'error'
        //   });
        //   return;
        // }

    if (!validateLoginForm()) return;

    // Clear any existing auto-dismiss timeout
    if (autoDismissRef.current) {
      clearTimeout(autoDismissRef.current);
      autoDismissRef.current = null;
    }

    setIsLoading(true);
    // setMessage({ text: "", type: "" });

    try {
      const response = await fetch(`${API_URL}/api/customer/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          email: email,
          password: password,
          referral_code: referralCode || null,
          "g-recaptcha-response": captchaToken, // send captcha token
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        setMessage({
          text: data.message || "Login failed. Please check your credentials.",
          type: "error",
        });
        clearMessageAfterDelay(10000);
        setIsLoading(false);
        return;
      }

      // Login successful
      localStorage.setItem("auth_token", data.access_token);
      setLoginData(data);

      // Store user data
      localStorage.setItem(
        "user",
        JSON.stringify(
          data.user || {
            name: data.user?.name || email.split("@")[0],
            email: email,
          },
        ),
      );

      // Set login flags
      sessionStorage.setItem("just_logged_in", "true");
      localStorage.setItem("just_logged_in_timestamp", Date.now().toString());

      // Clear first login flag
      localStorage.setItem("is_first_login", "false");

      // Clear referral code
      localStorage.removeItem("login_referral_code");

      setMessage({
        text: "Login successful! Your wallet has been opened in a new tab.",
        type: "success",
      });

      // Set auto-dismiss timeout for success message
      clearMessageAfterDelay(15000); // 15 seconds

      // Clear form fields
      clearFormFields();

      // Generate a token key for cross-tab communication
      const tempTokenKey = `customer_temp_token_${Date.now()}`;
      localStorage.setItem(tempTokenKey, data.access_token);

      // Build wallet URL with token parameter
      const walletUrl = `${window.location.origin}/customer/wallet`;

      // First, check if we're in a popup scenario
      const isPopup = window.opener || window.parent !== window;

      if (isPopup) {
        // We're in a popup, so redirect in current window
        window.location.href = walletUrl;
      } else {
        // Open wallet in new tab/window
        const newWindow = openInNewTab(walletUrl);

        // Set a timeout to close and retry if the new tab doesn't get the token
        setTimeout(() => {
          try {
            // Send token to new tab via postMessage if possible
            if (newWindow && newWindow.postMessage) {
              newWindow.postMessage(
                {
                  type: "LOGIN_SUCCESS",
                  token: data.access_token,
                  tempTokenKey: tempTokenKey,
                },
                window.location.origin,
              );
            }
          } catch (e) {
            console.log("Could not send message to wallet tab:", e);
          }

          // Clean up temp token after 30 seconds
          setTimeout(() => {
            localStorage.removeItem(tempTokenKey);
          }, 30000);
        }, 500);
      }
    } catch (error) {
      console.error("Login error:", error);
      setMessage({
        text: "Network error. Please check your connection and try again.",
        type: "error",
      });
      clearMessageAfterDelay(10000);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key && e.key.startsWith("customer_temp_token_")) {
        // Token was stored by another tab
        const token = localStorage.getItem(e.key);
        if (token) {
          localStorage.setItem("auth_token", token);
          // Navigate to wallet if we're on login page
          if (window.location.pathname.includes("/login")) {
            navigate("/customer/wallet");
          }
        }
      }
    };

    // Listen for storage events (from other tabs)
    window.addEventListener("storage", handleStorageChange);

    // Listen for postMessage events
    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) return;

      if (event.data && event.data.type === "LOGIN_SUCCESS") {
        localStorage.setItem("auth_token", event.data.token);
        if (event.data.tempTokenKey) {
          localStorage.removeItem(event.data.tempTokenKey);
        }
        navigate("/customer/wallet");
      }
    };

    window.addEventListener("message", handleMessage);

    // Clean up
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("message", handleMessage);
    };
  }, [navigate]);

  // Function to handle opening wallet portal
  const handleOpenWallet = () => {
    if (loginData && loginData.access_token) {
      // Reopen wallet with stored token
      const tempTokenKey = `customer_temp_token_${Date.now()}`;
      localStorage.setItem(tempTokenKey, loginData.access_token);
      const walletUrl = `${window.location.origin}/customer/wallet`;
      openInNewTab(walletUrl);
    } else {
      // If no loginData, try to use stored token
      const authToken = localStorage.getItem("auth_token");
      if (authToken) {
        const tempTokenKey = `customer_temp_token_${Date.now()}`;
        localStorage.setItem(tempTokenKey, authToken);
        const walletUrl = `${window.location.origin}/customer/wallet`;
        openInNewTab(walletUrl);
      } else {
        setMessage({
          text: "Please login again to access your wallet.",
          type: "error",
        });
        clearMessageAfterDelay(5000);
      }
    }
  };

  useEffect(() => {
    if (location.hash === "#customer-login") {
      const el = document.getElementById("customer-login");
      if (el) {
        const yOffset = -80;
        const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const name = params.get("name");
    const email = params.get("email");
    const firstLogin = params.get("firstLogin") === "true";

    if (token) {
      // User just completed OAuth login
      localStorage.setItem("auth_token", token);
      localStorage.setItem("user_name", name || "");
      localStorage.setItem("user_email", email || "");
      localStorage.setItem("is_first_login", firstLogin ? "true" : "false");

      // Show success message for OAuth login
      setMessage({
        text: "Login successful! Your wallet has been opened in a new tab.",
        type: "success",
      });
      setLoginData({ access_token: token });
      clearMessageAfterDelay(15000);

      // Remove token from URL to prevent showing on refresh
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  }, []);

  const SlidingCardsSection = () => {
    return (
      <div
        className="sliding-cards-section py-4 pt-5"
        style={{
          backgroundColor: "#001964",
          marginBottom: "0px",
          borderRadius: "20px",
          padding: "30px",
        }}
      >
        <div className="container">
          <h2
            className="text-center mb-4"
            style={{
              fontWeight: "bold",
              fontSize: "2.2rem",
              color: "#fff",
              textShadow: "0 2px 10px rgba(0,0,0,0.3)",
            }}
          >
            {/* Welcome to TopCoin UK, Where Loyalty Turns into Rewards! */}
            Welcome to TopCoin UK – Where Loyalty Earns Promotional Rewards
          </h2>

          <h2
            className="text-center mb-0"
            style={{
              fontWeight: "bold",
              fontSize: "1.8rem",
              color: "#fff",
              textShadow: "0 2px 10px rgba(0,0,0,0.3)",
            }}
          >
            Join as a Customer
          </h2>
          <p
            className="text-center mb-4"
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "1.1rem",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
            }}
          >
            {/* (Once you become a customer, you may request approval to become a
            TopCoin Agent.) */}
            (After becoming a customer, you may apply to participate in the 
            TopCoin referral programme.)
          </p>
          <p
            className="text-center mb-5"
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "1.1rem",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
            }}
          >
            {/* Join under our{" "}
            <strong>Authorised Senior Customer Advertising Participants</strong>{" "}
            or <strong>Company Charity</strong> and take part in our referral
            programme. */}
            You may join under an{" "}
            <strong>Authorised Senior Customer Advertising Participants</strong>{" "}
            or <strong>Company-approved structure </strong> and take part in the 
            promotional referral programme.
          </p>
          <p
            className="text-center mb-5"
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "1.1rem",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
            }}
          >
            Please choose & click an agent to join under.
          </p>

          {/* <ul className="btns_group unordered_list p-0 justify-content-center align-items-center mb-2">
            <li>
              <span
                className="ico_btn_outline"
                style={{
                  padding: "5px 10px",
                  cursor: "default",
                  pointerEvents: "none", // disables click & hover
                }}
              >
                <span
                  className="btn_label"
                  style={{
                    display: "inline-block",
                    padding: "0px",
                    backgroundColor: "transparent",
                    color: "#001964",
                    borderRadius: "10px",
                    fontWeight: "600",
                  }}
                >
                  JOIN
                </span>
              </span>
            </li>
          </ul> */}

          {/* Tab component */}
          {/* <div className="row justify-content-center mb-3 mt-4">
            <div className="col-md-6 col-lg-4">
              <div
                style={{
                  display: "flex",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  borderRadius: "50px",
                  padding: "5px",
                }}
              >
                <button
                  onClick={() => {}}
                  style={{
                    flex: 1,
                    padding: "12px 15px",
                    border: "none",
                    borderRadius: "50px",
                    backgroundColor: "#2D4CA8",
                    color: "white",
                    fontWeight: "600",
                    fontSize: "0.95rem",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                >
                  Customer Agents
                </button>
              </div>
            </div>
          </div> */}


          {/* Search Section */}
          <div className="row justify-content-center mb-4 mt-4">
            <div className="col-md-8 col-lg-6">
              <div className="input-group" style={{ marginBottom: "10px" }}>
                <input
                  type="text"
                  maxLength={255}
                  ref={searchInputRef}
                  className="form-control"
                  placeholder="Search agents by name or email..."
                  defaultValue={searchQuery}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      handleSearchClick();
                    }
                  }}
                  onFocus={() => {setIsAutoSliding(false); setSearchError("");}}
                  style={{
                    padding: "12px 20px",
                    borderRadius: "50px 0 0 50px",
                    border: "none",
                    fontSize: "0.95rem",
                    color: "#333",
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                  }}
                />
                {/* Reset/Clear Button */}
                <button
                  className="btn"
                  onClick={handleResetSearch}
                  title="Clear search"
                  style={{
                    backgroundColor: searchQuery ? "#ff6b6b" : "#e0e0e0",
                    color: searchQuery ? "white" : "#666",
                    border: "none",
                    borderLeft: "1px solid rgba(0,0,0,0.1)",
                    padding: "12px 15px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    if (searchQuery) {
                      e.target.style.backgroundColor = "#ff5252";
                    } else {
                      e.target.style.backgroundColor = "#d0d0d0";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (searchQuery) {
                      e.target.style.backgroundColor = "#ff6b6b";
                    } else {
                      e.target.style.backgroundColor = "#e0e0e0";
                    }
                  }}
                >
                  <FaTimes size={14} />
                </button>
                <button
                  className="btn"
                  onClick={handleSearchClick}
                  style={{
                    backgroundColor: "#2D4CA8",
                    color: "white",
                    border: "none",
                    borderRadius: "0 50px 50px 0",
                    padding: "12px 18px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#1a3a8f";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#2D4CA8";
                  }}
                >
                  <FaSearch />
                </button>
              </div>
              {searchError && (
                  <div
                    style={{
                      marginTop: "-10px",
                      textAlign: "center",
                      color: "#ff6b6b",
                      fontSize: "0.9rem",
                      fontWeight: "500",
                    }}
                  >
                    {searchError}
                  </div>
                )}

              {/* Customer Agent List (show 5, scroll for more) */}
              <div className="mt-5" style={{
                maxHeight: '320px',
                overflowY: displayCustomerAgents.length > 5 ? 'auto' : 'visible',
                border: '1px solid #e0e0e0',
                borderRadius: '10px',
                background: '#f9f9f9',
                marginTop: '10px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                padding: '8px 0',
              }}>
                <div style={{
                  fontWeight: 700,
                  color: '#001964',
                  fontSize: '1rem',
                  padding: '2px 18px 6px 18px',
                  borderBottom: '1px solid #e0e0e0',
                  background: '#f3f6fa',
                  borderTopLeftRadius: '10px',
                  borderTopRightRadius: '10px',
                  marginBottom: '2px',
                }}>
                  Customer Agents
                </div>
                {[...displayCustomerAgents]
                  .sort((a, b) => a.fullName.localeCompare(b.fullName))
                  .map((agent, idx, arr) => (
                    <div key={agent.id}
                      style={{
                        padding: '0px 15px',
                        borderBottom: idx !== arr.length - 1 ? '1px solid #eee' : 'none',
                        background: 'white',
                        borderRadius: '6px',
                        margin: '0 8px 6px 8px',
                        fontWeight: 600,
                        color: '#001964',
                        fontSize: '0.9rem',
                        textAlign: 'left',
                        letterSpacing: '0.01em',
                      }}
                    >
                      {agent.fullName} ({agent.location})
                    </div>
                  ))}
                {displayCustomerAgents.length > 5 && (
                  <div style={{ textAlign: 'center', padding: '8px', color: '#2D4CA8', fontWeight: 500, fontSize: '0.95rem' }}>
                    Scroll to see more agents...
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Running Agent Names Marquee with Manual Scroll Buttons */}
          {!isLoadingAgents && displayAgents.length > 0 && (
            <div className="row justify-content-center mb-4">
              <div className="col-12 position-relative">
                {/* Marquee Container */}
                <div
                  ref={marqueeRef}
                  style={{
                    position: "relative",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    borderRadius: "8px",
                    padding: "15px 20px",
                    overflow: "hidden",
                    minHeight: "50px",
                    display: "flex",
                    alignItems: "center",
                    marginTop: "20px",
                  }}
                >
                  <div
                    ref={marqueeContentRef}
                    style={{
                      display: "flex",
                      animation: !isMarqueePaused ? marqueeAnimation : "none",
                      whiteSpace: "nowrap",
                      gap: "25px",
                      padding: "0 10px",
                      width: "max-content",
                      animationPlayState: isMarqueePaused
                        ? "paused"
                        : "running",
                      transform: isMarqueePaused
                        ? `translateX(-${scrollPosition}px)`
                        : "translateX(0)",
                      transition: "transform 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      if (!isMarqueePaused) {
                        e.currentTarget.style.animationPlayState = "paused";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isMarqueePaused) {
                        e.currentTarget.style.animationPlayState = "running";
                      }
                    }}
                  >
                    {/* Display agents 3 times for seamless looping */}
                    {[...displayAgents, ...displayAgents, ...displayAgents].map(
                      (agent, index) => (
                        <span
                          key={`marquee-${agent.id}-${index}`}
                          onMouseEnter={(e) =>
                            handleAgentNameMouseEnter(agent, index, e)
                          }
                          onMouseLeave={handleAgentNameMouseLeave}
                          style={{
                            color: "white",
                            fontSize: "0.9rem",
                            fontWeight: "500",
                            cursor: "pointer",
                            padding: "8px 15px",
                            borderRadius: "20px",
                            backgroundColor: "rgba(255, 255, 255, 0.12)",
                            transition: "all 0.2s ease",
                            border: `1px solid ${agent.color}40`,
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            flexShrink: 0,
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.backgroundColor = `${agent.color}40`;
                            e.currentTarget.style.transform = "scale(1.03)";
                            e.currentTarget.style.boxShadow = `0 3px 8px ${agent.color}40`;
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.backgroundColor =
                              "rgba(255, 255, 255, 0.12)";
                            e.currentTarget.style.transform = "scale(1)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onClick={() => handleCardClick(agent.referralLink)}
                        >
                          <span
                            style={{
                              width: "8px",
                              height: "8px",
                              borderRadius: "50%",
                              backgroundColor: agent.color,
                              display: "inline-block",
                            }}
                          />
                          {agent.shortName || agent.fullName}
                          <span
                            style={{
                              fontSize: "0.7rem",
                              opacity: 0.7,
                              marginLeft: "3px",
                            }}
                          >
                            ({agent.location})
                          </span>
                        </span>
                      ),
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Loading State */}
          {isLoadingAgents && (
            <div className="text-center mb-5">
              <div className="spinner-border text-light" role="status">
                <span className="visually-hidden">Loading agents...</span>
              </div>
            </div>
          )}

          {/* No Results State (like WorkWithTCUKPage) */}
          {!isLoadingAgents && displayAgents.length === 0 && (
            <div className="text-center mb-5">
              <p style={{ color: "#ff6b6b", fontSize: "1.1rem" }}>
                No agents found matching your search criteria.
              </p>
              <button
                onClick={handleResetSearch}
                style={{
                  backgroundColor: "transparent",
                  color: "#4CAF50",
                  border: "1px solid #4CAF50",
                  borderRadius: "20px",
                  padding: "8px 20px",
                  fontSize: "0.95rem",
                  cursor: "pointer",
                  marginTop: "10px",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#4CAF50";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#4CAF50";
                }}
              >
                Show All Agents
              </button>
            </div>
          )}

          {/* Error State */}
          {agentsError && !isLoadingAgents && (
            <div className="text-center">
              <p style={{ color: "#ff6b6b" }}>{agentsError}</p>
            </div>
          )}

          <p
            className="text-center mb-5"
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "1.1rem",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
            }}
          >
            {/* Once someone joins TopCoin UK, they are given their own Personal ID
            (QR code), allowing them to take part in our customer referral
            system. TopCoin UK promotes participating businesses and helps
            customers discover them through advertising and referrals. */}
            When someone joins TopCoin UK, they receive a personal ID 
            (QR code) which allows them to participate in our customer referral 
            and loyalty programme. TopCoin UK promotes participating businesses 
            and helps customers discover them through structured advertising 
            and referral activity.
          </p>

          <h4
            className="text-center mb-4"
            style={{
              fontWeight: "bold",
              fontSize: "1.5rem",
              color: "#fff",
              textShadow: "0 2px 10px rgba(0,0,0,0.3)",
            }}
          >
            How Do TopCoin Agents Receive Free TopCoin?
          </h4>
          <p
            className="text-center mb-3"
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "1.1rem",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
            }}
          >
            {/* As a <strong>TopCoin UK Agent</strong>, you receive free TopCoin
            when you introduce someone to a participating business. */}
            As a <strong>TopCoin UK participant</strong>, you may receive free 
            TopCoin when you introduce someone to a participating business.
          </p>
          <div
            className="text-center "
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "1.1rem",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
            }}
          >
            <ul
              className="text-center mb-4"
              style={{
                color: "rgba(255, 255, 255, 0.9)",
                fontSize: "1.1rem",
                maxWidth: "800px",
                margin: "0 auto",
                lineHeight: "1.6",
                listStylePosition: "inside", // keep bullets close to text
                paddingLeft: 0,
                display: "inline-block", // center the whole list block
                textAlign: "left", // keep list items aligned nicely within the centered block
              }}
            >
              {/* <li>When someone you introduce makes a purchase,</li> */}
              <li>When a person you introduce makes a qualifying purchase,</li>
              {/* <li>
                You receive the<strong> same number of TopCoin</strong> they
                receive.
              </li> */}
              <li>
                You receive the<strong> same number of TopCoin</strong> they
                receive, in accordance with programme rules.
              </li>
            </ul>
          </div>
          <p
            className="text-center mb-3"
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "1.1rem",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
            }}
          >
            {/* TopCoin is provided <strong>free of charge </strong>as part of the
            TopCoin UK loyalty system. */}
            TopCoin is provided <strong>free of charge </strong>as part of the
            TopCoin UK promotional loyalty programme.
          </p>
          <p
            className="text-center mb-5"
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "1.1rem",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
            }}
          >
            {/* Be the reason others discover participating businesses and enjoy the
            benefits of loyalty rewards. */}
            Encourage others to discover participating businesses and take part in everyday loyalty rewards.
          </p>

          {/* Agent Preview Popup - FIXED POSITION FOR LARGE DEVICES */}
          {isPreviewVisible && hoveredAgent && (
            <div
              className="agent-preview"
              onMouseEnter={handlePreviewMouseEnter}
              onMouseLeave={handlePreviewMouseLeave}
              style={{
                position: "fixed",
                left: "50%",
                top: window.innerWidth <= 768 ? "50%" : "250px", // Fixed position for large devices
                transform:
                  window.innerWidth <= 768
                    ? "translate(-50%, -50%)"
                    : "translateX(-50%)",
                backgroundColor: "white",
                borderRadius: "12px",
                boxShadow: "0 8px 25px rgba(0, 0, 0, 0.25)",
                zIndex: 9999,
                width: window.innerWidth <= 768 ? "90vw" : "240px",
                maxWidth: "280px",
                padding: "15px",
                animation: "fadeIn 0.2s ease",
                border: `2px solid ${hoveredAgent.color}`,
                // Mobile-specific styles
                ...(window.innerWidth <= 768 && {
                  position: "fixed",
                  left: "50%",
                  top: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "90%",
                  maxWidth: "300px",
                  maxHeight: "80vh",
                  overflowY: "auto",
                }),
              }}
            >
              {/* Close button for mobile */}
              {window.innerWidth <= 4768 && (
                <button
                  onClick={() => {
                    setIsHovering(false);
                    setIsPreviewVisible(false);
                  }}
                  style={{
                    position: "absolute",
                    top: "8px",
                    right: "8px",
                    background: "none",
                    border: "none",
                    fontSize: "20px",
                    color: "#666",
                    cursor: "pointer",
                    zIndex: 10000,
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                    backgroundColor: "rgba(0,0,0,0.05)",
                  }}
                >
                  ×
                </button>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <img
                  src={hoveredAgent.profilePic}
                  alt={hoveredAgent.fullName}
                  style={{
                    width: window.innerWidth <= 768 ? "60px" : "45px",
                    height: window.innerWidth <= 768 ? "60px" : "45px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: `2px solid ${hoveredAgent.color}`,
                    marginRight: "10px",
                  }}
                />
                <div style={{ flex: 1 }}>
                  <h4
                    style={{
                      margin: 0,
                      color: "#001964",
                      fontSize: window.innerWidth <= 768 ? "1rem" : "0.9rem",
                      fontWeight: "600",
                      lineHeight: "1.2",
                    }}
                  >
                    {hoveredAgent.fullName}
                  </h4>
                  <p
                    style={{
                      margin: "3px 0 0 0",
                      color: hoveredAgent.color,
                      fontSize:
                        window.innerWidth <= 768 ? "0.85rem" : "0.75rem",
                      fontWeight: "500",
                    }}
                  >
                    {hoveredAgent.position}
                  </p>
                  <p
                    style={{
                      margin: "2px 0 0 0",
                      color: "#666",
                      fontSize: window.innerWidth <= 768 ? "0.8rem" : "0.7rem",
                    }}
                  >
                    📍 {hoveredAgent.location}
                  </p>
                </div>
              </div>

              <div
                style={{
                  backgroundColor: `${hoveredAgent.color}10`,
                  padding: "8px",
                  borderRadius: "6px",
                  marginBottom: "10px",
                }}
              >
                <p
                  style={{
                    margin: 0,
                    color: "#001964",
                    fontSize: window.innerWidth <= 768 ? "0.85rem" : "0.75rem",
                    textAlign: "center",
                    fontWeight: "500",
                    lineHeight: "1.3",
                  }}
                >
                  Join under {hoveredAgent.fullName.split(" ")[0]} as a Customer
                </p>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "10px",
                }}
              >
                <img
                  src={hoveredAgent.qrCode}
                  alt="QR Code"
                  style={{
                    width: window.innerWidth <= 768 ? "100px" : "80px",
                    height: window.innerWidth <= 768 ? "100px" : "80px",
                    borderRadius: "6px",
                    border: `1px solid ${hoveredAgent.color}`,
                  }}
                />
              </div>

              <div style={{ display: "flex", gap: "6px", marginTop: "10px" }}>
                <button
                  onClick={(e) => handleCopyLink(hoveredAgent.referralLink, e)}
                  style={{
                    flex: 1,
                    backgroundColor: hoveredAgent.color,
                    color: "white",
                    border: "none",
                    padding: window.innerWidth <= 768 ? "8px 10px" : "6px 8px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "4px",
                    fontSize: window.innerWidth <= 768 ? "0.8rem" : "0.7rem",
                    fontWeight: "500",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.opacity = "0.9";
                    e.target.style.transform = "translateY(-1px)";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.opacity = "1";
                    e.target.style.transform = "translateY(0)";
                  }}
                >
                  <FaCopy size={window.innerWidth <= 768 ? 14 : 12} /> Copy
                </button>
                <button
                  onClick={() => handleCardClick(hoveredAgent.referralLink)}
                  style={{
                    flex: 1,
                    backgroundColor: "#001964",
                    color: "white",
                    border: "none",
                    padding: window.innerWidth <= 768 ? "8px 10px" : "6px 8px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "4px",
                    fontSize: window.innerWidth <= 768 ? "0.8rem" : "0.7rem",
                    fontWeight: "500",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.opacity = "0.9";
                    e.target.style.transform = "translateY(-1px)";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.opacity = "1";
                    e.target.style.transform = "translateY(0)";
                  }}
                >
                  <FaLink size={window.innerWidth <= 768 ? 14 : 12} /> Join
                </button>
              </div>
            </div>
          )}

        </div>
      </div>
    );
  };

  // Success Message with Wallet Button Component
  const SuccessMessage = () => {
    if (message.type !== "success") return null;

    return (
      <div
        style={{
          textAlign: "center",
          padding: "10px",
          borderRadius: "8px",
          margin: "10px 0",
          fontWeight: "500",
          backgroundColor: "#e8f5e9",
          color: "#2e7d32",
          border: "1px solid #c8e6c9",
        }}
      >
        <p style={{ margin: "0 0 10px 0" }}>
          {message.text}
          <button
            onClick={handleDismissMessage}
            style={{
              background: "none",
              border: "none",
              color: "inherit",
              marginLeft: "10px",
              cursor: "pointer",
              float: "right",
              fontSize: "16px",
            }}
            title="Dismiss message"
          >
            ×
          </button>
        </p>
        <button
          onClick={handleOpenWallet}
          style={{
            backgroundColor: "#2D4CA8",
            color: "white",
            border: "none",
            padding: "10px 20px",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "bold",
            fontSize: "14px",
            marginTop: "5px",
          }}
        >
          Open Customer Wallet in New Tab
        </button>
      </div>
    );
  };

  return (
    <Fragment>
      <div
        className="index_ico page_wrapper "
        style={{
          backgroundColor: "#001964",
          color: "#fff",
        }}
      >
        <Header />
        <main className="page_content">
          {/* Use the enhanced SlidingCardsSection with Search, Marquee and Hover Preview */}
          <SlidingCardsSection />

          <section className="register_section section_decoration py-5" style={{minHeight:"0px"}}>
            <div className="container">
              <div className="row justify-content-center">
                {/* CENTERED LOGIN BOX - Full width on mobile, centered on larger screens */}
                <div
                  className="col-lg-4 col-md-8 col-sm-10"
                  id="customer-login"
                >
                  <div
                    className="bg-white text-center shadow p-4 margin-top-lg mx-auto"
                    style={{
                      color: "#000",
                      borderRadius: "20px",
                      maxWidth: "500px",
                      marginTop:"0px",
                      marginBottom: "40px",
                    }}
                  >
                    <div className="d-flex justify-content-center mb-0">
                      <img
                        src={coinIcon}
                        alt="TopCoin UK"
                        style={{ width: 115, height: 115 }}
                      />
                    </div>

                    <h4
                      className="fw-bold mb-1"
                      style={{
                        background:
                          "linear-gradient(90deg, #2D4CA8 52%, #9F4AFF 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        display: "inline-block",
                        fontSize: "1.2rem",
                      }}
                    >
                      {/* Welcome Back to
                      <br /> TopCoin UK */}
                      Customer /Customer Agent -Login
                    </h4>
                    <h3 className="sub-title mb-2">Enter your Email and Password</h3>

                    {/* Success Message with Wallet Button */}
                    <SuccessMessage />

                    {/* Regular Message display */}
                    {message.text && message.type !== "success" && (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "7px",
                          borderRadius: "8px",
                          margin: "10px 0",
                          fontWeight: "500",
                          fontSize: "0.9rem",
                          backgroundColor:
                            message.type === "error" ? "#ffebee" : "#e8f5e9",
                          color:
                            message.type === "error" ? "#c62828" : "#2e7d32",
                          border:
                            message.type === "error"
                              ? "1px solid #ffcdd2"
                              : "1px solid #c8e6c9",
                        }}
                      >
                        {message.text}
                        <button
                          onClick={handleDismissMessage}
                          style={{
                            background: "none",
                            border: "none",
                            color: "inherit",
                            marginLeft: "10px",
                            cursor: "pointer",
                            float: "right",
                            fontSize: "16px",
                          }}
                          title="Dismiss message"
                        >
                          ×
                        </button>
                      </div>
                    )}

                    {/* Login Form */}
                    <form onSubmit={handleLogin} className="text-start mb-4">
                      <div className="mb-1">
                        <label
                          className="form-label fw-semibold mb-0"
                          style={{ color: "#052C65", fontSize: "0.9rem" }}
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          maxLength={255}
                          className="form-control bg-white"
                          placeholder="Email Address"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          disabled={isLoading}
                          style={{
                            borderRadius: "8px",
                            padding: "8px",
                            border: "1px solid #ccc",
                            color: "black",
                          }}
                        />
                      </div>

                      <div className="mb-0 position-relative">
                        <label
                          className="form-label fw-semibold mb-0"
                          style={{ color: "#052C65", fontSize: "0.9rem" }}
                        >
                          Password
                        </label>
                        <div className="position-relative">
                          <input
                            type={passwordVisible ? "text" : "password"}
                            maxLength={50}
                            className="form-control bg-white"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            disabled={isLoading}
                            style={{
                              borderRadius: "8px",
                              padding: "8px",
                              border: "1px solid #ccc",
                              color: "black",
                              paddingRight: "40px",
                            }}
                          />
                          <span
                            onClick={() => setPasswordVisible(!passwordVisible)}
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "12px",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              color: "#666",
                              zIndex: 2,
                              height: "20px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {passwordVisible ? (
                              <FaEye size={18} />
                            ) : (
                              <FaEyeSlash size={18} />
                            )}
                          </span>
                        </div>
                      </div>

                      {/* Forgot Password Link */}
                      <div className="mb-2 text-end">
                        <a
                          href="/forgot-password"
                          style={{
                            color: "#2D4CA8",
                            fontWeight: "500",
                            textDecoration: "none",
                            fontSize: "0.9rem",

                          }}
                        >
                          Forgot Password?
                        </a>
                      </div>

                      {/* reCAPTCHA */}
                      <div style={{ marginBottom: "16px", display: "flex", alignItems: "center", flexDirection: "column", transform: "scale(0.77)",}}>
                          <ReCAPTCHA
                            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY} // replace with your actual site key
                            onChange={onCaptchaChange}
                          />
                          {/* { !captchaToken && message.type === "error" && message.text.includes("robot") && (
                            <span style={{ ...errorStyle, display: "block", marginTop: "8px" }}>
                              {message.text}
                            </span>
                          )} */}
                        </div>

                      <button
                        type="submit"
                        className="w-100 text-white fw-bold py-2"
                        disabled={isLoading}
                        style={{
                          backgroundColor: isLoading ? "#666" : "#0000A0",
                          borderRadius: "8px",
                          border: "none",
                          opacity: isLoading ? 0.7 : 1,
                          cursor: isLoading ? "not-allowed" : "pointer",
                        }}
                      >
                        {isLoading ? "Logging in..." : "Login"}
                      </button>
                    </form>

                    {/* <div className="d-flex align-items-center justify-content-center mb-3 mt-3">
                      <div
                        style={{
                          flex: 1,
                          height: "1px",
                          backgroundColor: "#ddd",
                        }}
                      ></div>
                      <span className="px-2" style={{ color: "#666" }}>
                        or
                      </span>
                      <div
                        style={{
                          flex: 1,
                          height: "1px",
                          backgroundColor: "#ddd",
                        }}
                      ></div>
                    </div> */}

                    {/* <div
                      className="d-flex justify-content-center"
                      style={{ gap: "12px" }}
                    > */}
                      {/* Google Login Button */}
                      {/* <button
                        onClick={(e) => {
                          e.preventDefault();
                          if (isLoading) return; */}

                          {/* // Build the Google OAuth URL with referral code */}
                          {/* const callbackUrl = `${window.location.origin}/auth/google/callback`;
                          let googleAuthUrl = `${API_URL}/api/auth/google?callback=${encodeURIComponent(
                            callbackUrl,
                          )}`; */}

                          {/* // Add referral code if available */}
                          {/* if (referralCode) {
                            googleAuthUrl += `&ref=${encodeURIComponent(
                              referralCode,
                            )}`;
                            localStorage.setItem(
                              "pending_oauth_referral",
                              referralCode,
                            );
                            console.log(
                              "🔗 Opening Google OAuth with referral (new tab):",
                              referralCode,
                            );
                          } */}

                          {/* // Use component helper to open in a new tab with fallbacks */}
                          {/* openInNewTab(googleAuthUrl);
                        }}
                        disabled={isLoading}
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#000000",
                          border: "none",
                          borderRadius: "8px",
                          padding: "12px 16px 5px 16px",
                          fontWeight: "500",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: isLoading ? "not-allowed" : "pointer",
                          opacity: isLoading ? 0.7 : 1,
                        }}
                      > */}
                        {/* <img src={sicon1} alt="Google" width="33" height="35" />
                      </button> */}

                      {/* Apple Login Button */}
                      {/* <button
                        onClick={handleAppleLogin}
                        disabled={isLoading}
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#000000",
                          border: "none",
                          borderRadius: "8px",
                          padding: "12px 16px",
                          fontWeight: "500",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: isLoading ? "not-allowed" : "pointer",
                          opacity: isLoading ? 0.7 : 1,
                        }}
                      >
                        <img
                          src={appleIcon}
                          alt="Apple"
                          width="40"
                          height="40"
                        />
                      </button> */}
                    {/* </div> */}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateX(-50%) translateY(-8px); }
            to { opacity: 1; transform: translateX(-50%) translateY(0); }
          }
          
          @keyframes marquee {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(calc(-100% / 3));
            }
          }
          
          .agent-preview {
            animation: fadeIn 0.2s ease;
          }
          
          /* Hide scroll buttons on very small screens */
          @media (max-width: 576px) {
            .scroll-buttons {
              display: none !important;
            }
          }
          
          iframe[title="reCAPTCHA"] {
            min-height: 100px !important;
          }
        `}
      </style>
    </Fragment>
  );
}

export default LoginPage;